document.addEventListener('DOMContentLoaded', () => {
  const iframeContainer = document.querySelector("#online-onboarding-iframe")
  if (iframeContainer) {
    const url = iframeContainer.dataset.onboardingUrl;
    const lang = iframeContainer.dataset.locale || 'en';
    const accountRedirectUrl = iframeContainer.dataset.accountRedirectUrl;
    const finishRedirectUrl = iframeContainer.dataset.finishRedirectUrl;
    LemonwayWidget.init(
      url,
      'lemonway-widget',
      {
        lang: lang,
        onPageChange: () => null,
        onMyAccount: () => handleRedirect(accountRedirectUrl),
        onFinish: () => handleRedirect(finishRedirectUrl),
      }
    );

    const handleRedirect = (redirectUrl) => {
      window.location.href = redirectUrl;
    }
  }
});